import {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {ErrorTypes} from 'utils/error-types';
import Button from './Button';
import Image from './Image';

const {LESSON, RESPONSE, INTRO_VIDEO} = ErrorTypes;

class Modal extends Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.values(ErrorTypes)).isRequired,
        onClose: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    _onClose = ({target}) => {
        if (['Modal-wrapper', 'Modal-close'].includes(target.className)) {
            this.props.onClose();
        }
    };

    render() {
        const {t, type, onClose} = this.props;
        let title;

        switch (type) {
            case LESSON:
                title = t('trouble.accessing');
                break;
            case RESPONSE:
                title = t('trouble.uploading');
                break;
            case INTRO_VIDEO:
                title = t('trouble.video');
                break;
        }

        return (
            <div className="Modal">
                <div className="Modal-shim" />
                <div
                    className="Modal-wrapper"
                    role="button"
                    tabIndex={0}
                    onClick={this._onClose}
                    onKeyPress={this._onClose}
                >
                    <div className="Modal-container">
                        <Image
                            src="../img/error.png"
                            alt={t('trouble.error')}
                        />
                        <h1>{title}</h1>
                        <p>{t('trouble.recommendation')}</p>
                        <Button color="secondary" onClick={onClose}>
                            {t('trouble.back')}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Modal);
